<template>
  <div class="v-spinner-ui"></div>
</template>
